
import { Switch, Route } from "react-router-dom";
import Home from "./pages/Home";
import Profile from "./pages/Profile";

import Main from "./components/layout/Main";
import Drivers from "./components/drivers/drivers";
import ActiveDrivers from "./components/drivers/activeDrivers";


import Passengers from "./components/passengers/passengers";
import Trips from "./components/trips/trips";
import Companies from "./components/company/companies";

import ReservationsList from "./components/reservation/reservationsList";

import Vehicles from "./components/vehicles/vehicles";
import VehicleTypes from "./components/vehicleTypes/vehicleTypes";
import InitialPrices from "./components/initialPrices/initialPrices";
// import Transactions from "./components/trips/transactions";

import SearchRadiuses from "./components/searchRadiuses/searchRadiuses";
import Map from "./components/drivers/map";

import Inspection from "./components/inspection/inspections";
import InspectionDetails from "./components/inspection/detail";

import TeamList from "./components/team/TeamList";










import DriversDetail from "./components/drivers/detail";
import PassengersDetail from "./components/passengers/detail";
import VehiclesDetail from "./components/vehicles/detail";
import CompanyDetails from "./components/company/detail";
import CommissionList from "./components/comission/commissions";






import User from "./components/userManagement/user";

import Permission from "./components/userManagement/permission";
import Role from "./components/userManagement/role";
import Login from "./components/userManagement/login";

import "antd/dist/antd.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import UpdateProfile from "./components/userManagement/updateProfile";
import TripDetail from "./components/trips/detail";
import ReservationDetail from "./components/reservation/detail";
import Dispatch from "./components/dispatch/dispatch";
import TripRequests from "./components/trips/tripRequests";
import TripRequestDetail from "./components/trips/tripRequestDetail";

import Owners from "./components/owners/owners";
import OwnerDetail from "./components/owners/detail";
import AgreementList from "./components/agreement/agreements";
import AgreementDetail from "./components/agreement/detail";
import TransactionDetail from "./components/transactions/detail";


import CustomerAgreementList from "./components/customerAgreement/customerAgreements";
import CustomerAgreementDetail from "./components/customerAgreement/detail";

import TransactionList from "./components/transactions/transactions";
import WithdrawalsList from "./components/transactions/withdrawals";

import TestimonialList from "./components/testimonial/TestimonialList";
import TestimonialDetails from "./components/testimonial/TestimonialDetails";
import TeamDetail from "./components/team/TeamDetail";
import AboutDetails from "./components/about/AboutDetails";
import AboutList from "./components/about/AboutList";
import ContactList from "./components/contact/ContactList";
import ContactDetails from "./components/contact/ContactDetails";
import FAQDetails from "./components/faq/FAQDetails";
import FAQList from "./components/faq/FAQList";

import ContactInfo from "./components/contactInfo/ContactList";


import ServiceList from "./components/service/ServiceList";


// import InspectionDetails from "./components/inspection/detail";






function App() {
  return (
    <div className="App">
      <Switch>
        <Route path="/" exact component={Login} />

        <Route path="/login" exact component={Login} />

        <Main>
          <Route exact path="/dashboard" component={Home} />
          <Route exact path="/profile" component={Profile} />
          <Route exact path="/drivers" component={Drivers} />
          <Route exact path="/activeDrivers" component={ActiveDrivers} />

          <Route exact path="/driverDetails/:id" component={DriversDetail} />
          <Route exact path="/passengers" component={Passengers} />
          <Route exact path="/trips" component={Trips} />
          <Route exact path="/contactInfo" component={ContactInfo} />


          <Route exact path="/contact" component={ContactList} />


          <Route exact path="/tripRequests" component={TripRequests} />


          <Route exact path="/companies" component={Companies} />

          <Route exact path="/reservations" component={ReservationsList} />
          <Route exact path="/inspections" component={Inspection} />

          <Route exact path="/vehicleTypes" component={VehicleTypes} />
          <Route exact path="/initialPrices" component={InitialPrices} />
          <Route exact path="/searchRadiuses" component={SearchRadiuses} />
          {/* <Route exact path="/transactions" component={Transactions} /> */}
          <Route exact path="/companyDetails/:id" component={CompanyDetails} />
          <Route exact path="/transactionDetails/:id" component={TransactionDetail} />
          <Route exact path="/teamDetails/:id" component={TeamDetail} />


          <Route exact path="/aboutDetails/:id" component={AboutDetails} />
          <Route exact path="/contactDetails/:id" component={ContactDetails} />
          <Route exact path="/faqDetails/:id" component={FAQDetails} />
          <Route exact path="/faq" component={FAQList} />

          <Route exact path="/services" component={ServiceList} />







          <Route exact path="/dispatch" component={Dispatch} />



          <Route exact path="/vehicles" component={Vehicles} />
          <Route exact path="/owners" component={Owners} />
          <Route exact path="/agreements" component={AgreementList} />
          <Route exact path="/withdrawals" component={WithdrawalsList} />

          <Route exact path="/customerAgreements" component={CustomerAgreementList} />


          <Route exact path="/about" component={AboutList} />


          <Route exact path="/commissions" component={CommissionList} />
          <Route exact path="/transactions" component={TransactionList} />
          <Route exact path="/testimonials" component={TestimonialList} />
          <Route exact path="/teams" component={TeamList} />



          <Route exact path="/map" component={Map} />



          <Route exact path="/passengerDetails/:id" component={PassengersDetail} />
          <Route exact path="/inspectionDetails/:id" component={InspectionDetails} />

          <Route exact path="/tripDetails/:id" component={TripDetail} />
          <Route exact path="/tripRequestDetails/:id" component={TripRequestDetail} />

          <Route exact path="/reservationDetails/:id" component={ReservationDetail} />

          <Route exact path="/testimonialDetails/:id" component={TestimonialDetails} />



          <Route exact path="/vehicleDetails/:id" component={VehiclesDetail} />
          <Route exact path="/ownerDetails/:id" component={OwnerDetail} />
          <Route exact path="/agreementDetails/:id" component={AgreementDetail} />
          <Route exact path="/customerAgreementDetails/:id" component={CustomerAgreementDetail} />







          <Route exact path="/users" component={User} />


          <Route exact path="/roles" component={Role} />
          <Route exact path="/permissions" component={Permission} />

          <Route exact path="/profile-update" component={UpdateProfile} />


          {/* <Redirect from="*" to="/dashboard" /> */}
        </Main>
      </Switch>
    </div>
  );
}

export default App;
